import * as React from 'react';
import {
  Create,
  SelectInput,
  SimpleForm,
  TextInput,
  ImageField,
  DateInput,
  ImageInput,
  required,
  CheckboxGroupInput,
  ArrayInput,
  SimpleFormIterator,
} from 'react-admin';
import {
  admin_users,
  gender_typs,
  purpose_types,
  status_types,
} from '../../utils/choices';
import { initalMetas } from '../../utils/initalMetas';

export const UserCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ImageInput
        source="images"
        label="Profile pictures"
        accept="image/*"
        multiple={true}
        validate={[required('Images are required')]}
        placeholder={<p>Drop your images here</p>}
      >
        <ImageField source="images" />
      </ImageInput>
      <SelectInput
        source="status"
        choices={status_types}
        defaultValue="verified"
      />
      <CheckboxGroupInput source="linked" choices={admin_users} />
      <TextInput source="name" validate={[required('User name is required')]} />
      <TextInput source="weight" label="weight(0-100)" />
      <TextInput disabled source="isFake" defaultValue={true} />
      <DateInput
        source="birthday"
        defaultValue={Math.floor(Math.random() * 11) + 1991 + '-06-06'}
      />
      <CheckboxGroupInput
        source="purpose"
        choices={purpose_types}
        validate={[required('Please select at least one purpose')]}
      />
      <SelectInput
        label="User gender"
        source="gender"
        choices={gender_typs}
        defaultValue="Woman"
      />
      <SelectInput
        source="interestedGender"
        choices={gender_typs}
        defaultValue="Man"
      />
      <ArrayInput source="metas" defaultValue={initalMetas}>
        <SimpleFormIterator>
          <TextInput source="question.name" label="Question name" disabled />
          <TextInput source="question.type" label="Input value type" disabled />
          <TextInput
            source="question.values"
            label="Input values selection"
            disabled
            multiline
          />
          <TextInput source="answer" label="Answer" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);
